module.exports = __webpack_public_path__ + "static/media/RightAlignBlue.915f1367.svg";